import { Box, Typography } from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";

import FormatDateSimple from "../../Helpers/FormatDateSimple";
import { Spinner } from "../Common/Spinner";
import TooltipWrapper from "../Common/TooltipWrapper";


function DoorLog({ entry, isLast }) {
	const { t } = useTranslation();
	const icon = entry?.access_type_obj?.image ?? null;

	return (
		<React.Fragment>
			<Box
				sx={{
					maxWidth: "100%",
					flexDirection: "row",
					padding: "15px",
					justifyContent: "space-between",
					display: "flex",
					alignItems: "center"
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center"
					}}
				>
					<div>
						<Typography
							style={{
								fontSize: "20px",
								fontWeight: "700"
							}}
						>
							{entry?.user?.name || entry?.user?.email || t("doors.deleted_user")}
						</Typography>
						<Typography
							style={{
								fontSize: 12,
								fontWeight: "700",
								color: ColorScheme.textSecondary
							}}
						>
							{entry?.user?.email}
						</Typography>
					</div>
				</Box>

				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						gap: "10px",
						backgroundColor: ColorScheme.secondary,
						padding: "5px 10px",
						borderRadius: "20px",
					}}
				>
					<Typography
						sx={{
							color: entry.device_status
								? ColorScheme.successPrimary
								: ColorScheme.dangerPrimary,
							fontSize: "14px",
							fontWeight: "thin"
						}}
					>
						{FormatDateSimple(new Date(entry.date))}
					</Typography>
					
					{entry.device_message ? (
						<TooltipWrapper title={entry.device_message}>
							<div
								style={{
									display: "flex",
									position: "relative",
									alignItems: "center",
									justifyContent: "center",
									backgroundColor: entry.device_status ? ColorScheme.successPrimary : ColorScheme.dangerPrimary,
									height: "8px",
									width: "8px",
									borderRadius: "50%",
								}}
							/>
						</TooltipWrapper>
					) : (
						<div
							style={{
								display: "flex",
								position: "relative",
								alignItems: "center",
								justifyContent: "center",
								backgroundColor: entry.device_status ? ColorScheme.successPrimary : ColorScheme.dangerPrimary,
								height: "8px",
								width: "8px",
								borderRadius: "50%",
							}}
						/>
					)}
					{icon != null && icon != undefined ? (
						<img
							style={{
								height: "16px",
								width: "16px",
							}}
							src={`data:image/svg+xml;utf8,${icon}`}
						/>
					) : (
						<img
							style={{
								height: "20px",
								width: "20px",
							}}
							src={require("../../Assets/Icons/MobileIcon.svg").default}
						/>
					)
				}
				</div>
			</Box>

			{!isLast && (
				<div
					style={{
						height: "1px",
						width: "100%",
						backgroundColor: ColorScheme.darkGrey + ColorScheme.opacity10,
					}}
				/>
			)}
		</React.Fragment>
	);
}

export const DoorLogs = ({ doorData }) => {
	const debug = false;

	const [doorDetails, setDoorDetails] = useState([]);
	const [loading, setLoading] = useState(true);
	const [loadMore, setLoadMore] = useState(false);
	const [page, setPage] = useState(1);

	const noMore = doorDetails.length === (page - 1) * 20;

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();

	function LoadNextPage() {
		setLoadMore(true);
		ApiCall("GET", `client/logs?door_id=${doorData.id}&page=${page}`)
			.then((door) => {
				if (door.length > 0) {
					setDoorDetails([...doorDetails, ...door]);
					setPage(page + 1);
					setLoadMore(false);
				}
			})
			.catch((error) => {
				if (debug) console.log(error);
				setLoading(false);
			});
	}

	useEffect(() => {
		setLoading(true);

		ApiCall("GET", `client/logs?door_id=${doorData.id}`)
			.then((door) => {
				setDoorDetails(door);
				setLoading(false);
				setPage(page + 1);
			})
			.catch((error) => {
				if (debug) console.log(error);
				setLoading(false);
			});
	}, []);

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
			{loading && <Spinner color={ColorScheme.primary}/>}
			{!loading && doorDetails.length === 0 && (
				<Typography
					sx={{
						fontSize: "20px",
						fontWeight: "normal",
						color: ColorScheme.black,
						marginTop: "20px"
					}}
				>
					{t("logs.not_found")}
				</Typography>
			)}
			{!loading && doorDetails.length > 0 && (
				<Box>
					<Box
						style={{
							display: "flex",
							flexDirection: "column",
							boxSizing: "border-box",
							borderRadius: "4px",
							width: "100%",
							margin: "auto",
							border: "1px solid " + ColorScheme.darkGrey + ColorScheme.opacity10,
							backgroundColor: ColorScheme.lightGrey
						}}
					>
						{doorDetails.map((entry, index) => (
							<DoorLog
								entry={entry}
								index={index}
								isLast={index === doorDetails.length - 1}
								key={index}
							/>
						))}
					</Box>
					<Box
						onClick={() => {
							if (noMore) LoadNextPage();
						}}
						sx={{
							width: "100%",
							height: 44,
							backgroundColor: noMore
								? ColorScheme.primary
								: "transparent",
							borderRadius: "4px",
							marginTop: "20px",
							justifyContent: "center",
							alignItems: "center",
							display: "flex",
							cursor: "pointer",
							"&:hover": {
								backgroundColor:
									noMore && ColorScheme.primary
							}
						}}
					>
						{loadMore ? (
							<Spinner small />
						) : (
							<Typography
								sx={{
									fontSize: "16px",
									color: noMore ? ColorScheme.secondary : ColorScheme.black
								}}
							>
								{noMore ? t("buttons.load_more") : ""}
							</Typography>
						)}
					</Box>
					<div style={{ height: "25px" }} />
				</Box>
			)}
		</div>
	);
};
